<template>
	<div class="mshiptypesFormHeader puiformheader">
	</div>
</template>

<script>
import PuiFormHeaderMixin from '@Pui9Mixins/PuiFormHeaderMixin';

export default {
	name: 'mshiptypes-form-header',
	mixins: [PuiFormHeaderMixin],
	data() {
		return {
			modelName: 'mshiptypes'
		};
	},
	computed: {
	}
}
</script>
